<template>
  <div class="action-tiles-grid">
    <!-- SMS -->
    <div class="action-tile" @click="openSmsPopup">
      <img src="/assets/img/svg/sms-blue.svg" class="action-tile-icon" />
      <span class="action-tile-label">שליחת SMS</span>
    </div>

    <!-- WhatsApp -->
    <div class="action-tile" @click="openWhatsapp">
      <img src="/assets/img/svg/wts-blue.svg" class="action-tile-icon" />
      <span class="action-tile-label">שליחת וואטסאפ</span>
    </div>

    <!-- קריאה לחדר -->
    <div
      class="action-tile"
      :class="{
        'action-tile--loading': isQueueCallLoading,
        'action-tile--success': isQueueCallSuccess
      }"
      @click="sendQueueCall"
    >
      <img
        v-if="!isQueueCallLoading && !isQueueCallSuccess"
        src="/assets/img/svg/bell-blue.svg"
        class="action-tile-icon"
      />
      <img
        v-if="isQueueCallLoading"
        src="/assets/img/svg/loader-blue.svg"
        class="action-tile-icon action-tile-spinner"
      />
      <img
        v-if="isQueueCallSuccess"
        src="/assets/img/svg/ok-green.svg"
        class="action-tile-icon"
      />
      <span class="action-tile-label">
        {{ isQueueCallSuccess ? "נשלח!" : "קריאה לחדר" }}
      </span>
    </div>

    <!-- טפסי הסכמה -->
    <router-link
      v-if="showIVF"
      class="action-tile"
      :to="`/cellosign/?appId=${appointmentId}`"
    >
      <img src="/assets/img/svg/file-doc-blue.svg" class="action-tile-icon" />
      <span class="action-tile-label">טפסי הסכמה</span>
    </router-link>

    <!-- סיכום רפואי (desktop only) -->
    <router-link
      v-if="!doctorSummary"
      class="action-tile action-tile--desktop-only"
      :to="'/app-add-summery/' + appointmentId"
    >
      <img src="/assets/img/svg/ic-pen-blue.svg" class="action-tile-icon" />
      <span class="action-tile-label">סיכום רפואי</span>
    </router-link>
  </div>
</template>

<script>
import SMSToPatient from "@/components/Popups/SMSToPatient.vue";
import Whatsapp from "@/components/Popups/Whatsapp.vue";
import Error from "@/components/Popups/Error";
import { sendQueueCall } from "@/api/api-quatro";
import { mapGetters } from "vuex";

export default {
  name: "AppActionTiles",
  props: {
    appointment: {
      required: true,
      type: Object
    },
    appointmentId: {
      required: true
    },
    doctorSummary: {
      default: null
    }
  },
  data() {
    return {
      isQueueCallLoading: false,
      isQueueCallSuccess: false
    };
  },
  computed: {
    ...mapGetters(["showIVF"])
  },
  methods: {
    openSmsPopup() {
      this.$modal.show(SMSToPatient, {
        patientName: `${this.appointment.firstName} ${this.appointment.lastName}`,
        patientPassport: this.appointment.passport,
        surgId: this.appointment.id,
        eventType: "appointment"
      });
    },
    openWhatsapp() {
      this.$modal.show(Whatsapp, { patientPhone: this.appointment.phone });
    },
    async sendQueueCall() {
      if (this.isQueueCallLoading) return;
      this.isQueueCallLoading = true;
      try {
        const fullName = `${this.appointment.firstName} ${this.appointment.lastName}`;
        await sendQueueCall(this.appointment.phone, fullName);
        this.isQueueCallLoading = false;
        this.isQueueCallSuccess = true;
        setTimeout(() => {
          this.isQueueCallSuccess = false;
        }, 2000);
      } catch (error) {
        this.isQueueCallLoading = false;
        this.$modal.show(Error);
      }
    }
  }
};
</script>

<style scoped>
.action-tiles-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
}

.action-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 120px;
  height: 90px;
  background: #fff;
  border: 1px solid #eff0f6;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.action-tile:hover {
  background-color: #f0f4ff;
  box-shadow: 0 2px 8px rgba(50, 73, 151, 0.1);
}

.action-tile-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.action-tile-label {
  font-size: 15px;
  color: #324997;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
}

.action-tile--loading {
  opacity: 0.6;
  pointer-events: none;
}

.action-tile--success {
  border-color: #01a87a;
}

.action-tile--success .action-tile-label {
  color: #01a87a;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.action-tile-spinner {
  animation: spin 1s linear infinite;
}

/* Mobile only */
@media screen and (max-width: 1199px) {
  .action-tile--desktop-only {
    display: none !important;
  }

  .action-tiles-grid {
    justify-content: center;
    gap: 10px;
    margin-bottom: 15px;
    padding: 12px;
    background: #fff;
    border-radius: 8px;
  }

  .action-tile {
    flex: 0 0 auto;
    width: 90px;
    height: 76px;
    border: 1px solid #eff0f6;
    border-radius: 8px;
    background: #fff;
  }

  .action-tile:hover {
    background: #f0f4ff;
    box-shadow: none;
  }

  .action-tile-icon {
    width: 24px;
    height: 24px;
  }

  .action-tile-label {
    font-size: 12px;
  }
}
</style>
